






















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

/**
 *  Component to paint a step's title and description, including
 *  the possibility to add an action to the right (slot).
 */
@Component
export default class StepHeading extends Vue {

    @Prop({ type: String, required: true })
    private title!: string;

    @Prop({ type: String })
    private description!: string;

}
